import { apiClient } from "../../../../../api/client";
import { CreditoAdhoc, CreateCreditoAdhocInput, Franquia } from "../types";

export const creditoAdhocService = {
  list: async (dbName: string, ops?: string) => {
    return apiClient.post<{ data: CreditoAdhoc[] }>("/gestorCreditoAdhocList", {
      dbName,
      ...(ops ? { ops } : {}),
    });
  },

  create: async (params: CreateCreditoAdhocInput) => {
    return apiClient.post<{ success: boolean; creditoAdhocId: number; solId: string }>(
      "/gestorCreditoAdhocCreate",
      params
    );
  },

  triggerBaixa: async (
    dbName: string,
    creditoAdhocId: number,
    userInfo: { email: string }
  ) => {
    return apiClient.post<{ success: boolean }>("/gestorCreditoAdhocBaixaStart", {
      dbName,
      creditoAdhocId,
      userInfo,
    });
  },

  listFranchises: async (dbName: string) => {
    return apiClient.post<{ data: Franquia[] }>("/gestorEntregoCadastroViz", {
      dbName,
    });
  },
};
